import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { ToastService } from '@shared/services/toast.service';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [TranslocoModule],
})
export class ToastComponent {
  toastService = inject(ToastService);
  toasts: any;
  constructor() {
    this.toasts = this.toastService.getToasts();
  }

  clearToast(id: number) {
    this.toastService.clearNotification(id);
  }
}
